import { HttpStatusCodeGroup } from '@40seas/entities/common';
import { EnumColor } from '@40seas/frontend/common/providers';

export const httpStatusGroupColorMapping = {
    [HttpStatusCodeGroup.Informational]: 'info',
    [HttpStatusCodeGroup.Success]: 'success',
    [HttpStatusCodeGroup.Redirection]: 'warning',
    [HttpStatusCodeGroup.ClientError]: 'error',
    [HttpStatusCodeGroup.ServerError]: 'error',
} as { [key in HttpStatusCodeGroup]: EnumColor };
